import apiClient from "../api/apiClient";
import { Notify } from "../../helpers/notification";
import { getDashboardData, getProfile } from "./user";

const PAYMENT_LOADING = () => {
  return { type: "PAYMENT_LOADING" };
};

const PAYMENT_COMPLETE = () => {
  return { type: "PAYMENT_COMPLETE" };
};

export const GetAllPayment = (cb, page) => (dispatch, getState) => {
  dispatch({ type: "SET_APP_LOADING", payload: true });

  // @deprecated — old MongoDB server
  // Api.get(`api/payment/getPayment/` + page)
  //   .then((response) => {
  //     cb && cb(response.data.data);
  //     dispatch({ type: "ALL_PAYMENT", payload: response.data.data });
  //   })
  //   .catch((err) => {
  //     console.log({ err });
  //     cb && cb(false);
  //   })
  //   .catch(() => {
  //     Notify("danger", "Something Bad Happened :(");
  //   })
  //   .finally(() => {
  //     dispatch({ type: "SET_APP_LOADING", payload: false });
  //   });

  const leaseId = getState().USER_REDUCER?.userData?.activeLease || "";
  apiClient.get(`/payments?page=${page}&pageSize=20${leaseId ? `&leaseId=${leaseId}` : ""}`)
    .then((response) => {
      const result = response.data.data;
      cb && cb(result.data);
      dispatch({ type: "ALL_PAYMENT", payload: result });
    })
    .catch((err) => {
      console.log({ err });
      cb && cb(false);
    })
    .catch(() => {
      Notify("danger", "Something Bad Happened :(");
    })
    .finally(() => {
      dispatch({ type: "SET_APP_LOADING", payload: false });
    });
};

export const MakePayment = (payload, cb) => (dispatch) => {
  dispatch(PAYMENT_LOADING());

  // @deprecated — old MongoDB server
  // Api.post("api/payment/capturePayment", payload)
  //   .then((response) => {
  //     dispatch(GetAllPayment(() => {}, 1));
  //     dispatch(PAYMENT_COMPLETE());
  //     dispatch(getDashboardData(() => {}));
  //     cb && cb(response.data);
  //   })
  //   .catch((err) => {
  //     cb && cb(err?.response?.data);
  //     console.log({ err });
  //     dispatch(PAYMENT_COMPLETE());
  //   });

  apiClient.post("/payments/capture", payload)
    .then((response) => {
      dispatch(GetAllPayment(() => {}, 1));
      dispatch(GetRecentPayments(() => {}));
      dispatch(PAYMENT_COMPLETE());
      dispatch(getDashboardData(() => {}));
      cb && cb(response.data);
    })
    .catch((err) => {
      cb && cb(err?.response?.data);
      console.log({ err });
      dispatch(PAYMENT_COMPLETE());
    });
};

export const GetRecentPayments = (cb) => (dispatch, getState) => {
  dispatch({ type: "SET_APP_LOADING", payload: true });
  const leaseId = getState().USER_REDUCER?.userData?.activeLease || "";
  apiClient.get(`/payments/recent${leaseId ? `?leaseId=${leaseId}` : ""}`)
    .then((response) => {
      cb && cb(response.data.data);
      dispatch({ type: "RECENT_PAYMENTS", payload: response.data.data });
    })
    .catch((err) => {
      console.log({ err });
      cb && cb(false);
    })
    .catch(() => {
      Notify("danger", "Something Bad Happened :(");
    })
    .finally(() => {
      dispatch({ type: "SET_APP_LOADING", payload: false });
    });
};

export const ViewPayment = (id, reqParams) => (dispatch) => {
  dispatch(PAYMENT_LOADING());
  Notify("info", "...generating PDF please wait!")
  apiClient.get(`payments/${id}/invoice?${reqParams}`)
    .then((response) => {
      dispatch(PAYMENT_COMPLETE());
      dispatch({ type: "VIEW_PAYMENT", payload: response.data });
    })
    .catch(() => {
      dispatch(PAYMENT_COMPLETE());
      Notify("danger", "Something Bad Happened :(");
    });
};


export const handleRecurringPayment = (payload, cb) => dispatch => {
  dispatch(PAYMENT_LOADING());
  return apiClient.post("api/payment/recurringPayment", payload)
    .then(() => {
      cb && cb (null, true);
      dispatch({ type: 'PAYMENT_SUBMITTED' });
      dispatch(getProfile());
    })
    .catch((error) => {
      cb && cb (error.response.data, false);
      dispatch(PAYMENT_COMPLETE());
    })
    .catch(() => {
      Notify("danger", "Something Bad Happened :(");
    });
};

export const clearPaymentDetails = () => (dispatch) => {
  dispatch({ type: "CLEAR_PAYMENTDETAILS" });
};

export const GetPaymentData = (payload, cb) => () => {
  apiClient.get(`/payments/chart`, {
    params: { startDate: payload.startDate, endDate: payload.endDate },
  })
    .then((response) => {
      cb && cb(response.data.data);
    })
    .catch((err) => {
      console.log(err);
      cb && cb(false);
    });
};
